import request from "@/utils/request";

export default function cameraPage(current, size, params) {
    return request({
        url: `/camera/page/${current}/${size}`,
        method: 'get',
        params
    })
}